module.exports = "<div class=\"image-wrapper\" *ngIf=\"data.thumbnailUrl && data.value.length\" (click)=\"openGallery()\">\n    <div class=\"image\" [ngStyle]=\"{'background': 'url(' + data.thumbnailUrl + ') no-repeat'}\"></div>\n</div>\n\n<!--{{ data | json }}-->"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-datatable/src/components/values/images/images.component.html
// module id = ./libs/chassis-datatable/src/components/values/images/images.component.html
// module chunks = main